import { useContext, useCallback } from 'react';
import { AuthContext } from '../context/AuthContext';
import { apiUrl } from '../config';

export const useApi = () => {
  const { token, refreshToken, logout, refreshAccessToken } = useContext(AuthContext);

  const renewAccessToken = useCallback(async () => {
    const newToken = await refreshAccessToken();
    if (newToken) return newToken;
    if (typeof window !== 'undefined') {
      window.alert('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
    }
    logout();
    throw new Error('No se pudo refrescar el token');
  }, [refreshAccessToken, logout]);

  // fetch seguro con refresco automático (sin cola offline)
  const secureFetch = useCallback(
    async (url, options = {}, retry = true) => {
      if (!url) {
        console.error('URL es undefined en secureFetch');
        throw new Error('URL no puede ser undefined');
      }

      const fullUrl = url.startsWith('http') ? url : apiUrl(url);

      const headers = options.headers ? { ...options.headers } : {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      try {
        console.log(`🌐 useApi: Llamando a ${fullUrl}`);
        const res = await fetch(fullUrl, { ...options, headers });

        if (res.status === 401 && retry && refreshToken) {
          const newToken = await renewAccessToken();
          headers['Authorization'] = `Bearer ${newToken}`;
          return await fetch(fullUrl, { ...options, headers });
        }

        return res;
      } catch (err) {
        console.error('❌ useApi: Error en fetch:', err);
        throw err;
      }
    },
    [token, refreshToken, renewAccessToken]
  );

  return { secureFetch };
}; 